// This file is generated by Slice Machine. Update with care!

import SectionSkills from './SectionSkills';

export { SectionSkills };

export const components = {
  section_skills: SectionSkills,
};
